import React from 'react';
import { ArrowRight } from 'lucide-react';
import HeroImage from '../components/HeroImage';

function Pricing() {
  const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSfKLHkPyKGOxjUMO3-sN5oQwwlnmhONJjOHqXEwUcaamfPeJQ/viewform?usp=header";

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen mx-[4.2mm] mt-[4.2mm]">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-[#00ffff]/10 via-transparent to-[#ff0000]/10 animate-gradient rounded-lg z-10"></div>
          <div className="absolute inset-0 rounded-lg overflow-hidden">
            <HeroImage 
              src="https://images.unsplash.com/photo-1434626881859-194d67b2b86f?auto=format&fit=crop&q=80&w=1920&h=1080" 
              alt="Pricing hero"
              priority={true}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50 rounded-lg z-20"></div>
        </div>

        <div className="relative h-full flex items-center z-30">
          <div className="max-w-7xl mx-auto px-4">
            <h1 className="text-5xl font-bold text-center text-white mb-6">
              The Price of Success
            </h1>
            <p className="text-xl text-white/80 text-center max-w-3xl mx-auto mb-8">
              Your business has needs specific to you, so every solution should be tailored to suit those needs. Success rarely ever entails a one-size-fits-all approach, and neither does our pricing model. However, our consultations are free!
            </p>
            <div className="flex justify-center">
              <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-[#00ffff] text-white rounded-lg hover:bg-[#ff0000] transition-colors font-semibold inline-flex items-center"
              >
                Book a Consultation
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricing;